angular.module('unergie.main')
.controller('proofOfResidenceModalCtrl', ($scope, $uibModalInstance, ApiUser,
    idContract, idAccount, ReferencesService, PrmUtilsService, AlertManager, AuthService, ErrorCatcher) => {
    $scope.idContract = idContract

    $scope.people = []

    $scope.addPeople = function () {
        if ($scope.people.length < 5) {
            return $scope.people.push({
                civ: 'M.',
                sn: '',
                givenname: '',
            })
        }
    }

    $scope.delPeep = (index) => $scope.people.splice(index, 1)

    const getParams = () =>
        ({
            firstnames: (_.map($scope.people, 'givenname')).join(','),
            lastnames: (_.map($scope.people, 'sn')).join(','),
            civs: (_.map($scope.people, 'civ')).join(','),
        })


    $scope.url = function () {
        let url = `/api-user/admin/account/${idAccount}/documents/${idContract}/proofofresidence`
        if ($scope.people.length > 0) {
            const p = getParams()
            url += `?firstnames=${p.firstnames}&lastnames=${p.lastnames}&civs=${p.civs}`
        }
        return url
    }

    $scope.sendByMail = function () {
        $scope.sending = true
        return ApiUser.sendProofOfResidence(_.assign({ idAccount, idContract }, getParams())).$promise.then(() =>
            AlertManager.success('Email envoyé'))
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.sending = false
        })
    }

    // RETURN OK
    $scope.ok = () => $uibModalInstance.close()

    $scope.close = () => $uibModalInstance.dismiss()
})
